import React, { useEffect } from "react";

import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import './App.css'
import AOS from 'aos';
import 'aos/dist/aos.css'; // <-- Import AOS styles
import Home from "./pages/Home";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Single from "./pages/Single";
import { AlertProvider } from './AlertContext'; // update path
import Category from "./pages/Category";
import Favorites from "./pages/Favorites";
import Profile from "./pages/Profile";
import SingleLive from "./pages/SingleLive";
import Contact from "./pages/Contact";

import PrivateRoute from './components/PrivateRoute';

export default function App() {

  useEffect(() => {
    AOS.init({});
  }, []);

  return (
    <AlertProvider>
      <BrowserRouter>


        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<Contact />} />

          {/* Protected routes */}
          <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/video" element={<PrivateRoute><Single /></PrivateRoute>} />
          <Route path="/live" element={<PrivateRoute><SingleLive /></PrivateRoute>} />
          <Route path="/category" element={<PrivateRoute><Category /></PrivateRoute>} />
          <Route path="/favorites" element={<PrivateRoute><Favorites /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        </Routes>



      </BrowserRouter>
    </AlertProvider>

  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);